import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .progress {
    border: 1px solid #1c4b8c;
    width: 33vw;
    border-radius: 99px;
    height: 34px;
    padding: 2px;
    .line {
      border-radius: 99px;
      height: 28px;
      background: #3c82c0;
    }
  }
`;
